import Lens from '../../../shared/Icons/Lens';

const ActivitiesToolbar = ({ query, setQuery }) => {
  return (
    <div className="p-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between border-b">
      <div className="relative w-full sm:w-80">
        <Lens/>
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar por nombre"
          className="w-full border border-gray-300 pl-9 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"
        />
      </div>
    </div>
  );
};

export default ActivitiesToolbar;
